import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogContentText,
  Button,
} from "@mui/material";

export function CmConfirmExitDialog({
  openModal,
  handleClose,
  handleClickClose,
  totalCount,
}) {
  return (
    <Dialog
      open={openModal}
      aria-labelledby="cm-confirm-exit-dialog-title"
      maxWidth="xs"
      fullWidth
    >
      <DialogTitle
        id="cm-confirm-exit-dialog-title"
        sx={{ fontWeight: 500, fontSize: "20px", color: "rgba(0, 0, 0, 0.87)" }}
      >
        ¿Deseas salir sin publicar?
      </DialogTitle>
      <DialogContent>
        <DialogContentText
          sx={{ fontWeight: 400, fontSize: "14px", color: "rgba(0, 0, 0, 0.87)" }}
        >
          Tienes {totalCount} cambios pendientes. Si cierras esta ventana, los
          cambios permanecerán en la tabla pero no se enviarán. Deberás volver a
          publicar más tarde.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={handleClose}
          variant="outline"
          sx={{
            fontFamily: "Roboto",
            fontSize: "14px",
            fontWeight: 500,
            color: "#354887",
            height: "32px",
            textTransform: "uppercase",
            border: "1px solid #354887",
            "&:hover": { backgroundColor: "#F5F5F5", borderColor: "#2A3B6F", color: "#2A3B6F" },
          }}
        >
          Salir sin publicar
        </Button>
        <Button
          onClick={handleClickClose}
          variant="contained"
          sx={{
            fontFamily: "Roboto",
            fontSize: "14px",
            fontWeight: 500,
            color: "#ffffff",
            backgroundColor: "#354887",
            height: "32px",
            textTransform: "uppercase",
            "&:hover": { backgroundColor: "#2c3b6f" },
          }}
        >
          Volver a la revisión
        </Button>
      </DialogActions>
    </Dialog>
  );
}
